import { clamp } from "lodash";
import React, { useState } from "react";
import Modal from "react-modal";

const ContactUsModal = ({ closeModal, toggleModal }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  return (
    <Modal
      isOpen={closeModal}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          width: "400px",
        },
      }}
    >
      <h1 className="text-center">Contact Us</h1>
      <button
        onClick={toggleModal}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: "none",
          border: "none",
          cursor: "pointer",
        }}
      >
        X
      </button>
      <form
        className="container justify-content-center"
        onSubmit={(e) => e.preventDefault()}
      >
        <label htmlFor="name" className="modalLabel">
          Name: *
        </label>
        <input
          type="text"
          className="modalInput"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <label htmlFor="email" className="modalLabel">
          Enter your email here : *
        </label>
        <input
          type="email"
          className="modalInput"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <label htmlFor="phone" className="modalLabel">
          Phone:
        </label>
        <input
          type="number"
          className="modalInput"
          placeholder="Phone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <div className="d-flex justify-content-center">
          <button
            className="modalSubmit"
            onClick={() => console.log(email, name, phone)}
          >
            Request Callback
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ContactUsModal;
